/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsShuffle: {
  name: 'arrows-shuffle';
  data: string;
} = {
  name: 'arrows-shuffle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.707 4.293a1 1 0 1 0-1.414 1.414l.293.293h-1.589A5.994 5.994 0 0 0 11 8.682 5.994 5.994 0 0 0 6 6H3a1 1 0 0 0 0 2h3a4 4 0 1 1 0 8H3a1 1 0 1 0 0 2h3a5.994 5.994 0 0 0 5-2.682A5.994 5.994 0 0 0 16 18h1.586l-.293.293a1 1 0 0 0 1.414 1.414l2-2a1 1 0 0 0 0-1.414l-2-2a1 1 0 0 0-1.414 1.414l.293.293H16a4 4 0 0 1 0-8h1.586l-.293.293a1 1 0 0 0 1.414 1.414l2-2a1 1 0 0 0 0-1.414l-2-2Z" fill="currentColor"/></svg>`,
};
